import { render } from "./ScoreAT.vue?vue&type=template&id=ccc09138&scoped=true"
import script from "./ScoreAT.vue?vue&type=script&lang=js"
export * from "./ScoreAT.vue?vue&type=script&lang=js"

import "./ScoreAT.vue?vue&type=style&index=0&id=ccc09138&scoped=scoped&lang=less"
import "./ScoreAT.vue?vue&type=style&index=1&id=ccc09138&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc09138"]])

export default __exports__